import { SuperAdminConstants } from '../../../_constants';

const initialState = { getAnalyticsActiveBatchesLoading: true, data: '', error: false };

export function getAnalyticsActiveBatchesReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_ANALYTICS_ACTIVE_BATCHES:
            return {
                getAnalyticsActiveBatchesLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_ANALYTICS_ACTIVE_BATCHES:
            return {
                getAnalyticsActiveBatchesLoading: false,
                data: action.getAnalyticsActiveBatches,
                error: false
            };
        case SuperAdminConstants.ANALYTICS_ACTIVE_BATCHES_ERROR:
            return {
                getAnalyticsActiveBatchesLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageBatches/getAnalyticsActiveBatches.reducer.js